import HomeMainContent from "./HomeContent";

export default HomeMainContent;